import { useState } from "react";
import { Download, Share, X } from "lucide-react";
import { useInstallPrompt } from "@/lib/pwa";

export const InstallButton = ({ label = "Install app", color = "#CCFF00", testid = "pwa-install-btn", className = "" }) => {
  const { canPrompt, install, installed, isIOS } = useInstallPrompt();
  const [help, setHelp] = useState(false);
  if (installed) return null;

  const onClick = async () => {
    if (canPrompt) await install();
    else setHelp(true);
  };

  return (
    <>
      <button
        data-testid={testid}
        onClick={onClick}
        className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-xs font-bold uppercase tracking-wider transition-transform duration-200 hover:-translate-y-0.5 ${className}`}
        style={{ borderColor: color, color }}
      >
        <Download className="h-3.5 w-3.5" /> {label}
      </button>
      {help && (
        <div className="fixed inset-0 z-[80] flex items-end justify-center bg-black/70 p-4 sm:items-center" onClick={() => setHelp(false)}>
          <div className="w-full max-w-sm rounded-lg border border-white/10 bg-[#111827] p-6 text-left" onClick={(e) => e.stopPropagation()} data-testid="pwa-install-help">
            <div className="flex items-start justify-between">
              <p className="font-display text-2xl font-extrabold uppercase text-white">Save to home screen</p>
              <button onClick={() => setHelp(false)} data-testid="pwa-help-close" className="text-slate-400 hover:text-white"><X className="h-5 w-5" /></button>
            </div>
            {isIOS ? (
              <p className="mt-3 text-sm leading-relaxed text-slate-300">
                In Safari tap <Share className="inline h-4 w-4" /> <b>Share</b>, then choose <b>Add to Home Screen</b>.
              </p>
            ) : (
              <p className="mt-3 text-sm leading-relaxed text-slate-300">
                Open your browser menu (⋮) and choose <b>Install app</b> or <b>Add to Home screen</b>. It will open full-screen like a native app.
              </p>
            )}
          </div>
        </div>
      )}
    </>
  );
};
